<template>
  <v-simple-table style="width: 100%;">
    <thead>
      <tr>
        <th class="text-left">
          วันที่
        </th>
        <th class="text-left">
          เลขชุด
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="game_round in game.rounds"
        :key="game_round.uuid"
      >
        <td>{{ safeDate(game_round.round_rooms[0] && game_round.round_rooms[0].win_number && game_round.round_rooms[0].win_number.created_at) }}</td>
        <td>{{ game_round.round_rooms[0] && game_round.round_rooms[0].win_number && game_round.round_rooms[0].win_number.four || 'xxxx' }}</td>
      </tr>
    </tbody>
  </v-simple-table>
</template>
<script>

export default {
  props : {
    game : {
      type: Object,
      default: () => ({})
    },
  },
  methods: {
    safeDate (date) {
      return date ? this.$options.filters.dateFormat(date) : '-';
    }
  }
}
</script> 